import { ContactRole } from '@shared/types/contact-role';
import { GroupType } from '@shared/types/group-type';

export const contactRequirementsByGroupTypes: {
  groupType: GroupType;
  title: string;
  description: string;
  requiredContactRoles: ContactRole[];
  excludedContactRoles: ContactRole[];
}[] = [
  {
    groupType: 'sub_distributor',
    title: 'Contact Role Assignment',
    description: 'Add or select people who have the authority to represent your organisation',
    requiredContactRoles: ['primary', 'strategic', 'accounts'],
    excludedContactRoles: [],
  },
  {
    groupType: 'partner',
    title: 'Contact Role Assignment',
    description: 'Add or select people who have the authority to represent your organisation',
    requiredContactRoles: ['primary', 'strategic', 'accounts'],
    excludedContactRoles: [],
  },
  {
    groupType: 'customer',
    title: 'Contact Role Assignment',
    description: 'Add or select team members',
    requiredContactRoles: ['primary'],
    excludedContactRoles: ['strategic'],
  },
  {
    groupType: 'sub_distributor_partner',
    title: 'Contact Role Assignment',
    description: 'Add or select people who have the authority to represent your organisation',
    requiredContactRoles: ['primary'],
    excludedContactRoles: [],
  },
];
